import { useLocale } from '../i18n/LocaleContext'
import SEOHead from '../components/SEOHead'

export default function Terms() {
  const { t } = useLocale()

  return (
    <section className="section-padding bg-white">
      <SEOHead title={t.terms.metaTitle} description={t.terms.metaDescription} />
      <div className="container-max max-w-3xl">
        <h1 className="mb-2">{t.terms.title}</h1>
        <p className="text-text-muted text-sm mb-8">{t.terms.lastUpdated}</p>

        <div className="space-y-8">
          {t.terms.content.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-heading font-medium mb-3">{section.heading}</h2>
              <div className="text-text-secondary leading-relaxed whitespace-pre-line">
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
